import { render, staticRenderFns } from "./PDFCatalogs.vue?vue&type=template&id=626618e5&"
import script from "./PDFCatalogs.vue?vue&type=script&lang=js&"
export * from "./PDFCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports